import { VerticalView } from './vertical-view';
/**
 * week view
 */
export class Week extends VerticalView {
    /**
     * Constructor for week view
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    constructor(parent) {
        super(parent);
        this.viewClass = 'e-week-view';
    }
    startDate() {
        return this.getViewStartDate();
    }
    endDate() {
        return this.getViewEndDate();
    }
    /**
     * Get module name.
     *
     * @returns {string} Returns the module name.
     */
    getModuleName() {
        return 'week';
    }
}
